import { NgModule } from '@angular/core';
import { HierarchyItemComponent } from './components/hierarchy-item/hierarchy-item.component';
import { HierarchyComponent } from './components/hierarchy/hierarchy.component';
import { SharedModule } from '@shared/shared.module';
import { HierarchySubordinateItemsComponent } from './components/hierarchy-subordinate-items/hierarchy-subordinate-items.component';

const comp = [HierarchyComponent, HierarchyItemComponent, HierarchySubordinateItemsComponent];

@NgModule({
  declarations: [...comp],
  imports: [SharedModule],
  exports: [...comp],
})
export class HierarchyModule {}
